import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWidth, ZINDEX_MODAL } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { EGeolocationFailedPopup } from 'components/Generic/__partials/GeolocationFailedPopup/types';
import { Modal, ModalButtons } from 'components/Modal';
import { Button } from 'newcomponents/UI/Button';
import { useEventbus } from 'newhooks/generic/useEventbus';
import './index.less';

export const GeolocationFailedPopup = () => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);

  useEventbus({
    [EGeolocationFailedPopup.ShowPopup]: () => {
      setModalVisible(true);
    }
  });

  return (
    <Modal
      centered
      visible={modalVisible}
      closable={false}
      zIndex={ZINDEX_MODAL + 1}
      maskStyle={{ zIndex: ZINDEX_MODAL, backgroundColor: 'var(--v3-black-2)' }}
      width={isMobile() ? ModalWidth.MOBILE_350 : ModalWidth.DESKTOP_420}
      title={t('account.geolocationFailedPopupTitle')}
      image={{
        lib: 'generic',
        name: 'attentionGeneric',
        theme: 'colored'
      }}
      className="geolocationFailedPopup"
    >
      <div
        className="geolocationFailedPopup__info"
        dangerouslySetInnerHTML={{
          __html: t('account.geolocationFailedPopupInfo')
        }}
      />

      <ModalButtons>
        <Button
          fullwidth
          type="primary"
          onClick={() => {
            setModalVisible(false);
          }}
        >
          {t('account.ok')}
        </Button>
      </ModalButtons>
    </Modal>
  );
};
